import { ImageProviderName } from '../../../__generated__/queries-web';
import { PhotoCollapsesTypes } from './types';

export const PHOTOS_TECHNICAL_SOURCES = {
  ...(Object.keys(PhotoCollapsesTypes).reduce(
    (acc, key) => ({
      ...acc,
      [key]: key,
    }),
    {},
  ) as { [key in keyof typeof PhotoCollapsesTypes]: string }),
  ...(Object.keys(ImageProviderName).reduce(
    (acc, key) => ({
      ...acc,
      [key]: `API_${ImageProviderName[
        (key as unknown) as ImageProviderName
      ].toUpperCase()}`,
    }),
    {},
  ) as {
    [key in ImageProviderName]: string;
  }),
};
